export default class OfflineInvestor {
  id?: number;
  name: string;
  amountInvested: number;
  investmentType: string;

  constructor(entity: OfflineInvestor) {
    this.id = entity.id;
    this.name = entity.name;
    this.amountInvested = entity.amountInvested;
    this.investmentType = entity.investmentType;
  }
}



// WEBPACK FOOTER //
// ./src/entities/OfflineInvestor.tsx